import { Checkbox, TableCell, TableHead, TableRow } from '@material-ui/core';
import React from 'react';

import VolunteerTime from 'entities/volunteerTime/model';
import { truthy } from 'utils/truthy';

export const VolunteerTimesTableHead = ({
  volunteerTimes,
  selectedItems,
  anyStatusUpdating,
  setSelectedItems,
}: {
  volunteerTimes?: VolunteerTime[] | null;
  selectedItems: string[];
  anyStatusUpdating: boolean;
  setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const handleSelectAll = () => {
    const selectedItemsForCurrentPage = selectedItems.filter((item) =>
      volunteerTimes?.some((vt) => vt.id === item)
    );
    const isAllSelectedForCurrentPage =
      selectedItemsForCurrentPage.length === volunteerTimes?.length;

    if (isAllSelectedForCurrentPage) {
      // if all selected for current page then deselect all from the current page
      setSelectedItems(selectedItems.filter((item) => !selectedItemsForCurrentPage.includes(item)));
    } else {
      // if not selected all then select the rest of all for current page
      const notSelectedCurrentPageItems = (volunteerTimes || [])
        .map((item) => (!selectedItemsForCurrentPage.includes(item.id) ? item.id : null))
        .filter(truthy);

      setSelectedItems((prevSelectedItems) => [
        ...prevSelectedItems,
        ...notSelectedCurrentPageItems,
      ]);
    }
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell size="medium">
          <Checkbox
            color="primary"
            checked={volunteerTimes?.every((volunteerTime) =>
              selectedItems.includes(volunteerTime.id)
            )}
            onChange={handleSelectAll}
            disabled={anyStatusUpdating}
          />
        </TableCell>
        <TableCell size="medium">Employee</TableCell>
        <TableCell size="medium">Employee Location</TableCell>
        <TableCell size="medium">Type</TableCell>
        <TableCell size="medium">Deed</TableCell>
        <TableCell size="medium">Hours</TableCell>
        <TableCell size="medium">Details</TableCell>
      </TableRow>
    </TableHead>
  );
};
